import React from 'react'
import './index.less'
let checkTime = 0

class ActivitySlider extends React.Component {
    constructor (props) {
        super(props)
        this.timer = null
        this.state = {
            styleContent: this.props.data.style,
            hourNum: null, // 倒计时 时
            minuteNum: null, // 倒计时 分
            secondNum: null, // 倒计时 秒
            showDownTime: false
        }
    }

    componentDidMount () {
        this.checkStatus()
    }

    componentWillUnmount () {
        window.clearInterval(this.timer)
    }

    checkStatus = () => {
        const { timeDiff, activitySliderList } = this.props

        const currentVenue = activitySliderList.find(item => item.selectStatus === 1)
        const venueStartTime = new Date(currentVenue.venueStartTime.split(' ')[0].split('-').join('/') +
            ' ' + currentVenue.venueStartTime.split(' ')[1]).getTime()
        const venueEndTime = new Date(currentVenue.venueEndTime.split(' ')[0].split('-').join('/') +
            ' ' + currentVenue.venueEndTime.split(' ')[1]).getTime()
        const serverTime = timeDiff + new Date().getTime()

        if (this.timer) {
            window.clearInterval(this.timer)
        }
        if (currentVenue.venueStatus === 1) {
            const timeOne = Math.floor((venueStartTime - serverTime) / 1000)
            if (timeOne <= 0) {
                this.setState({
                    showDownTime: true,
                    secondNum: 0,
                    minuteNum: 0,
                    hourNum: 0
                })
                return
            }
            if (timeOne > 24 * 60 * 60) {
                this.setState({
                    showDownTime: false
                }, () => this.downTime(timeOne))
            }
            if (timeOne < 24 * 60 * 60) {
                this.setState({
                    showDownTime: true
                }, () => this.downTime(timeOne))
            }
        }

        /**
         * 初进页面时是开始抢购的状态
         */
        if (currentVenue.venueStatus === 2) {
            const timeOne = Math.floor((venueEndTime - serverTime) / 1000)
            if (timeOne <= 0) {
                this.setState({
                    showDownTime: true,
                    secondNum: 0,
                    minuteNum: 0,
                    hourNum: 0
                })
                return
            }
            this.setState({
                showDownTime: true
            }, () => this.downTime(timeOne))
        }
        /**
         * 结束抢购的状态
         */
        if (currentVenue.venueStatus === 3) {
            this.setState({
                showDownTime: false
            })
        }
    }

    downTime = (time) => {
        const { activitySliderList } = this.props
        const currentVenue = activitySliderList.find(item => item.selectStatus === 1)
        this.setState({
            secondNum: Math.floor(time % 60),
            minuteNum: Math.floor(time / 60 % 60),
            hourNum: Math.floor(time / 3600 % 24)
        })
        this.timer = setInterval(() => {
            if (currentVenue.venueStatus === 1 && time < 24 * 60 * 60) {
                this.setState({
                    showDownTime: true
                })
            }
            if (time <= 0) {
                clearInterval(this.timer)
                return
            }
            ++checkTime
            if (checkTime === 60 && time > 0) {
                checkTime = 0
                clearInterval(this.timer)
                this.checkStatus()
            }
            time--
            this.setState({
                secondNum: Math.floor(time % 60),
                minuteNum: Math.floor(time / 60 % 60),
                hourNum: Math.floor(time / 3600 % 24)
            })
        }, 1000)
    }

    getVenueStatus = (code) => {
        if (code === 1) {
            return '敬请期待'
        }
        if (code === 2) {
            return '抢购中'
        }
        if (code === 3) {
            return '已结束'
        }
    }

    // 处理时间数据 2017/09/12
    handleTimeData = (data) => {
        const time = data.split(' ')[0]
        return time.split('-').join('/')
    }

    // 处理场次时间数据 12:00
    handleStartTime = (data) => {
        const time = data.split(' ')[1].split(':')
        return time[0] + ':' + time[1]
    }

    changeVenue = (item) => {
        const { changeCurrentVenue } = this.props
        changeCurrentVenue(item)
    }

    lenTwo = (num) => {
        return num < 10 ? ('0' + num).toString() : num.toString()
    }

    render () {
        const { styleContent, hourNum, minuteNum, secondNum, showDownTime } = this.state
        const { activitySliderList, handleRule, data: { trackId, position }, buriedPointEvent } = this.props
        const currentVenue = activitySliderList.find(item => item.selectStatus === 1)
        return (
            <div className={'activityVenueContainer'} style={{ marginTop: `${styleContent.paddingTop / 75}rem` || 0 }}>
                {activitySliderList && activitySliderList.length > 1 && <ul>
                    {
                        activitySliderList.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <li
                                        className={item.selectStatus === 1 ? 'checkLi' : ''}
                                        style={item.selectStatus === 1 ? {
                                            background: `linear-gradient(-180deg,${
                                                styleContent.minSelectBackgroundColor || '#fff'
                                            } 0%,${
                                                styleContent.maxSelectBackgroundColor || '#fff'
                                            } 93%)`
                                        } : {}}
                                        key={item.id}
                                        onClick={() => {
                                            buriedPointEvent({
                                                button_name: `${trackId}-${this.handleStartTime(item.venueStartTime)}`,
                                                button_id: `${item.id}`,
                                                button_order: `${index + 1}`,
                                                area_order: position,
                                                button_area: `${position}-${trackId}`
                                            })
                                            this.changeVenue(item)
                                        }}
                                    >
                                        <span>{this.handleStartTime(item.venueStartTime)}</span>
                                        <span>{this.getVenueStatus(item.venueStatus)}</span>
                                    </li>
                                </React.Fragment>

                            )
                        })
                    }
                </ul>}
                {
                    currentVenue.isShowCountDown === 1 && <div className={'contentTimeContainer'}>
                        <div className={'contentTime'}>
                            { currentVenue.venueStatus === 1 && !showDownTime && (<div className={'contentTimeLeft'}>
                                <span>{this.handleTimeData(currentVenue.venueStartTime)}</span>
                                <span>({this.handleStartTime(currentVenue.venueStartTime)}开抢)</span>
                            </div>)}
                            { currentVenue.venueStatus === 1 && showDownTime && (<div className={'contentTimeLeft'}>
                                <span>抢购倒计时</span>
                                <p>
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(hourNum)}</span>:
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(minuteNum)}</span>:
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(secondNum)}</span>
                                </p>

                            </div>)}
                            { currentVenue.venueStatus === 2 && showDownTime && (<div className={'contentTimeLeft'}>
                                <span>本场还剩</span>
                                <p>
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(hourNum)}</span>:
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(minuteNum)}</span>:
                                    <span className={'contentTimeNum'}
                                        style={{ background: styleContent.countDownBackgroundColor || '#4A4A4A' }}>{this.lenTwo(secondNum)}</span>
                                </p>

                            </div>)}
                            {currentVenue.venueStatus === 3 && !showDownTime && (<div className={'contentTimeLeft'}>
                                <span className={'venueEnd'}>本场次活动已结束</span>
                            </div>)}
                            {currentVenue.isShowEntry === 1 && (<div onClick={() => handleRule(currentVenue)} className={'contentTimeRight'}>
                                <span>{currentVenue.entryName}</span>
                                <i className={'arrowIcon'} />
                            </div>)}
                        </div>
                    </div>
                }

            </div>
        )
    }
}

export default ActivitySlider
